// Page Home
require('./pages/home');